import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMapPointer24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMapPointer24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.173 9.692c0 2.227-1.157 5.007-2.706 7.307-.76 1.129-1.566 2.069-2.279 2.707-.357.32-.662.538-.9.668-.143.08-.23.11-.269.12a1.4 1.4 0 0 1-.272-.12 5 5 0 0 1-.905-.67c-.717-.64-1.527-1.58-2.292-2.709-1.559-2.3-2.723-5.079-2.723-7.303A6.19 6.19 0 0 1 12.019 3.5c3.41 0 6.154 2.763 6.154 6.192m1.5 0C19.673 15 14.327 22 12.019 22S4.327 15 4.327 9.692A7.69 7.69 0 0 1 12.019 2c4.249 0 7.654 3.444 7.654 7.692m-6.077 0a1.577 1.577 0 1 1-3.154 0 1.577 1.577 0 0 1 3.154 0m1.5 0a3.077 3.077 0 1 1-6.154 0 3.077 3.077 0 0 1 6.154 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMapPointer24);
